import { render, staticRenderFns } from "./SearchFilter.vue?vue&type=template&id=510add68&"
import script from "./SearchFilter.vue?vue&type=script&lang=ts&"
export * from "./SearchFilter.vue?vue&type=script&lang=ts&"
import style0 from "./SearchFilter.vue?vue&type=style&index=0&id=510add68&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports